var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"print-report"}},[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"form":_vm.body,"header":_vm.header,"board":_vm.board,"projectId":_vm.projectId,"boardId":_vm.boardId,"postId":_vm.postId}}):_vm._e(),(_vm.err)?_c('span',[_vm._v(_vm._s(_vm.err))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }